var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from '../icon';
import Label from '../label';
import Popover from '../popover';
import { Styled } from './style';
export var SCREEN_STATUS_ENUM;
(function (SCREEN_STATUS_ENUM) {
    SCREEN_STATUS_ENUM["ONLINE"] = "online";
    SCREEN_STATUS_ENUM["OFFLINE"] = "offline";
    SCREEN_STATUS_ENUM["LIVE"] = "live";
    SCREEN_STATUS_ENUM["TRIAL"] = "trial";
    SCREEN_STATUS_ENUM["PAUSED"] = "paused";
    SCREEN_STATUS_ENUM["SUSPENDED"] = "suspended";
})(SCREEN_STATUS_ENUM || (SCREEN_STATUS_ENUM = {}));
var ScreenState = /** @class */ (function (_super) {
    __extends(ScreenState, _super);
    function ScreenState(props) {
        return _super.call(this, props) || this;
    }
    ScreenState.prototype.render = function () {
        var displayState;
        switch (this.props.status) {
            case SCREEN_STATUS_ENUM.LIVE:
            case SCREEN_STATUS_ENUM.ONLINE:
                displayState = (React.createElement(Popover, { trigger: React.createElement(Label, { color: "green", circular: true },
                        React.createElement(FormattedMessage, { id: "ui_component.screen_state.live", defaultMessage: "online" })), content: "Screen online", position: "top center", inverted: true }));
                break;
            case SCREEN_STATUS_ENUM.SUSPENDED:
                displayState = (React.createElement(Popover, { trigger: React.createElement(Label, { color: "red", className: "popover", circular: true },
                        this.props.count && React.createElement("span", { className: "count" }, this.props.count),
                        React.createElement(FormattedMessage, { id: "ui_component.screen_state.suspended", defaultMessage: "suspended" }),
                        ' ',
                        React.createElement(Icon, { name: "info" })), content: "Screen suspended. Please check with your admin.", position: "top center", inverted: true }));
                break;
            case SCREEN_STATUS_ENUM.PAUSED:
                displayState = (React.createElement(Popover, { trigger: React.createElement(Label, { color: "orange", circular: true },
                        this.props.count && React.createElement("span", { className: "count" }, this.props.count),
                        React.createElement(FormattedMessage, { id: "ui_component.screen_state.paused", defaultMessage: "deactivated" }),
                        " ",
                        React.createElement(Icon, { name: "pause" })), content: "Screen deactivated", position: "top center", inverted: true }));
                break;
            case SCREEN_STATUS_ENUM.TRIAL:
                displayState = (React.createElement(Popover, { trigger: React.createElement(Label, { className: "trial", circular: true },
                        this.props.count && React.createElement("span", { className: "count" }, this.props.count),
                        React.createElement(FormattedMessage, { id: "ui_component.screen_state.trial_mode", defaultMessage: "Preview Mode" }),
                        ' ',
                        React.createElement(Icon, { name: "info" })), content: "Screen on Preview Mode", position: "top center", inverted: true }));
                break;
            case SCREEN_STATUS_ENUM.OFFLINE:
                displayState = (React.createElement(Popover, { trigger: React.createElement(Label, { color: "grey", circular: true },
                        this.props.count && React.createElement("span", { className: "count" }, this.props.count),
                        React.createElement(FormattedMessage, { id: "ui_component.screen_state.offline", defaultMessage: "offline" })), content: "Screen offline", position: "top center", inverted: true }));
                break;
            default:
                displayState = (React.createElement(Popover, { trigger: React.createElement(Label, { circular: true },
                        React.createElement(FormattedMessage, { id: "ui_component.screen_state.unknown", defaultMessage: "unknown" })), content: "Screen status 'Unknown'", position: "top center", inverted: true }));
                break;
        }
        return React.createElement(Styled, null, displayState);
    };
    return ScreenState;
}(React.Component));
export default ScreenState;
//# sourceMappingURL=index.js.map